import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { Link } from 'gatsby';

export const Wrapper = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: white;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    display: none;
  }
`;

export const MenuItem = styled.button`
  width: 100%;
  background-color: white;
  border: 0;
  font-size: 1.8rem;
  border-bottom: 1px solid lightGrey;
  padding: ${vars.spacingL} ${vars.spacingM};
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-weight: ${vars.fontWeightMedium};
  }
`;

export const MobileNavLink = styled(Link)`
  text-decoration: none;
  width: 100%;
  background-color: white;
  border: 0;
  font-size: 1.8rem;
  border-bottom: 1px solid lightGrey;
  padding: ${vars.spacingL} ${vars.spacingM};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${vars.fontWeightMedium};
`;

export const MenuFooter = styled.div`
  padding: ${vars.spacingL} ${vars.spacingM};
  margin-bottom: 87px;
`;

export const FooterText = styled.p`
  font-size: 1.2rem;
  margin-bottom: ${vars.spacingXs};
`;

export const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: ${vars.spacingM};
  margin-bottom: ${vars.spacingM};
`;

export const Copyright = styled.p`
  font-size: 1.8rem;
  margin-bottom: ${vars.spacingM};
`;

export const FooterLink = styled(Link)`
  font-size: 1.4rem;
  margin-right: ${vars.spacingS};
`;

export const LanguageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -4px;
`;

export const AddressWrapper = styled.div`
  display: flex;
  align-items: top;
  justify-content: space-between;
`;

export const Address = styled.div`
  margin-right: ${vars.spacingS};
`;
